/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'az-cluster';

export const azClusterBreadcrumbTitle = `${prefix}.azClusterBreadcrumbTitle`;

export const ENGLISH = {
    [azClusterBreadcrumbTitle]: 'AZ Cluster',
};
